import React, { Component } from "react";

import styles from "./CustomerRatings.module.css";
import Language from "../utils/Language";

const ROTATE_MS = 6000;
const FADE_MS = 300;

class CustomerRatings extends Component {
  constructor(props) {
    super(props);
    this.state = { index: 0, fade: false };
    this.interval = undefined;
  }

  componentDidMount() {
    this.interval = setInterval(this.advance, ROTATE_MS);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  advance = () => {
    const quotes = this.getQuotes();
    this.setState({ fade: true });
    setTimeout(() => {
      this.setState(state => ({
        index: (state.index + 1) % quotes.length,
        fade: false
      }));
    }, FADE_MS);
  };

  getQuotes() {
    const all = require("../constants/customer_quotes.json");
    return all[Language.GetLangId()] || all[0];
  }

  render() {
    const quotes = this.getQuotes();
    const { index, fade } = this.state;

    return (
      <section className={styles.Section}>
        <div className={styles.Eyebrow}>Reviews</div>
        <h2 className={styles.Title}>
          {Language.GetString("what_players_think")}
        </h2>
        <p className={styles.Subtitle}>
          {Language.GetString("what_players_subtitle")}
        </p>

        <div className={styles.QuoteWrap}>
          <div className={styles.QuoteMark}>“</div>
          <p
            className={
              fade ? `${styles.Quote} ${styles.QuoteFade}` : styles.Quote
            }
          >
            {quotes[index]}
          </p>
          <div className={styles.Dots}>
            {quotes.map((_, i) => (
              <span
                key={i}
                className={
                  i === index ? `${styles.Dot} ${styles.DotActive}` : styles.Dot
                }
              />
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default CustomerRatings;
